import Model from "~/models/_Model";
import Course from "./Course";
import Department from "./Department";

export default class Recommendation extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/courserecommendations";
  }

  // Set the resource route of the model
  resource() {
    return "recommendations";
  }

  relations() {
    return {
      department_info: Department,
      recommended_course_info: Course,
    };
  }

  // Computed Attributes
  get display_source() {
    return `${this.staff_id}: ${this.course_id} - ${this.course_description}`;
  }

  get display_recommendation() {
    return (
      `${this.recommendation_type}: ${this.recommendation}` +
      (this.recommended_course_info
        ? " - " + this.recommended_course_info.DESCRIPTION_CLEAN
        : "")
    );
  }

  get display_department() {
    if (!this.department_info) {
      return this.course_department_id;
    }
    return this.department_info.DESCRIPTION;
  }
}
